// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__DiKzm","title":"Images90_title__1BvGi","images":"Images90_images__3tTKF"};